import loadable from '@loadable/component';
import 'b2w-react-photoswipe/lib/photoswipe.css';
import '../app.css';

export default loadable(() => import('b2w-react-photoswipe'));
